import lighthouseService from '../services/lighthouse';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    superUsers: [],
    originalSuperUserIds: [],
    saving: false,
    hasChanged: false,
    loading: false,
    errors: []
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_SUPER_USERS = 'SET_SUPER_USERS';
export const UPDATE_SUPER_USERS = 'UPDATE_SUPER_USERS';
export const SET_SAVING = 'SET_SAVING';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERRORS = 'SET_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {

    switch ( action.type ) {
        case SET_SUPER_USERS: {
            return {
                ...state,
                superUsers: action.superUsers,
                originalSuperUserIds: action.originalSuperUserIds,
                hasChanged: false
            };
        }
        case UPDATE_SUPER_USERS: {
            const hasChanged = !arraysHaveSameStrings(
                action.superUsers.map( su => su.id ),
                state.originalSuperUserIds
            );
            return {
                ...state,
                superUsers: action.superUsers,
                hasChanged
            };
        }
        case SET_SAVING: {
            return {
                ...state,
                saving: action.saving
            };
        }
        case SET_LOADING: {
            return {
                ...state,
                loading: action.loading
            };
        }
        case SET_ERRORS: {
            return {
                ...state,
                errors: [ ...state.errors, action.error ]
            };
        }
        case CLEAR_ERRORS: {
            return {
                ...state,
                errors: []
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */

export function loadSuperUsers( accessToken, companyId, hierarchyId ) {
    const LighthouseService = new lighthouseService( accessToken, companyId );

    return async ( dispatch ) => {
        try {
            dispatch( setLoading( true ) );

            const superUsers = await LighthouseService.getSuperUsers( hierarchyId );
            const formatted = superUsers.map( su => ( { ...su, key: su.id } ) );
            dispatch( setSuperUsers( formatted ) );
            return formatted;

        } catch ( error ) {
            dispatch( addError( error ) );
        } finally {
            dispatch( setLoading( false ) );
        }
    };
}

export function saveSuperUsers( accessToken, companyId, isUmbrella, hierarchyId ) {
    const LighthouseService = new lighthouseService( accessToken, companyId );
    return async ( dispatch, getState ) => {
        dispatch( setSaving( true ) );
        try {
            const { superUsers, hasChanged } = isUmbrella ? getState().roster.superUsers : getState().superUsers;
            if ( !hasChanged ) {
                dispatch( setSaving( false ) );
                return;
            }
            const superUsersPersonIds = superUsers.map( user => user.id );
            const res = await LighthouseService.createSuperUsers( hierarchyId, superUsersPersonIds );
            dispatch( loadSuperUsers( accessToken, companyId, hierarchyId ) );
            return res;
        } catch ( error ) {
            dispatch( addError( error ) );
            throw error;
        } finally {
            dispatch( setSaving( false ) );
        }
    };
}

export function setSuperUsers( superUsers ) {
    return {
        type: SET_SUPER_USERS,
        superUsers: superUsers,
        originalSuperUserIds: superUsers.map( su => su.id )
    };
}

export function updateSuperUsers( superUsers ) {
    return {
        type: UPDATE_SUPER_USERS,
        superUsers
    };
}

export function setSaving( saving ) {
    return {
        type: SET_SAVING,
        saving
    };
}

export function setLoading( loading ) {
    return {
        type: SET_LOADING,
        loading
    };
}

export function addError( error ) {
    return {
        type: SET_ERRORS,
        error
    };
}

export function clearErrors() {
    return {
        type: CLEAR_ERRORS
    };
}

function arraysHaveSameStrings( arr1, arr2 ) {
    const set1 = new Set( arr1 );
    const set2 = new Set( arr2 );
    if ( set1.size !== set2.size ) {
        return false;
    }

    for ( let item of set1 ) {
        if ( !set2.has( item ) ) {
            return false;
        }
    }

    return true;
}